import React, { useState, useEffect } from 'react'
import CKEditor from 'ckeditor4-react'
import { Table, Row, Col, ControlLabel, RadioGroup, Radio, CheckPicker, SelectPicker } from 'rsuite'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { getMaxLengthData, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import moment from 'moment'
import DatePickerCustom from '../../../components/datePicker/DatePickerCustom'
import { DATE_PICKER_FORMAT } from '../../../constants/date'
import { isEmpty, cloneDeep } from 'lodash-es'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'

export default function NotificationOfAssetsForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  rowData,
  useType,
  ...props
}) {
  const [formSchema, setFormSchema] = useState(schema?.form)
  const maxLength = getMaxLengthData(schema?.form?.notificationMessage?.validators)?.value
  const [textLength, setTextLength] = useState(0)
  const [notiMessage, setNotiMessage] = useState()
  const [checkRadio, setCheckRadio] = useState('0')
  const [usersRole, setUsersRole] = useState()
  const [notiStartDate, setNotiStartDate] = useState()
  const [notiStopDate, setNotiStopDate] = useState()
  const [startDateCounting, setStartDateCounting] = useState()
  const [stopDateCounting, setStopDateCounting] = useState()
  const [useTypeST, setUseTypeST] = useState(useType)

  useEffect(() => {
    if (rowData) {
      console.log('rowdata => ', rowData)
      let usersRoles = null
      if (!isEmpty(rowData?.activeRole)) {
        let newArr = rowData?.activeRole?.split(',')
        usersRoles = cloneDeep(newArr || [])
      }

      setTextLength(rowData.message.length || 0)

      setValue(formSchema.notificationMessage.name, rowData.message)
      setValue(formSchema.activeStatus.name, rowData.isActive)
      setValue(formSchema.usersRole.name, usersRoles)
      setValue(
        formSchema?.notificationStartDate.name,
        moment(rowData?.notificationStartDate, DATE_PICKER_FORMAT).toDate()
      )
      setValue(
        formSchema?.notificationStopDate.name,
        moment(rowData?.notificationEndDate, DATE_PICKER_FORMAT).toDate()
      )
      setValue(
        formSchema?.startDateCounting.name,
        moment(rowData?.openSystemStartDate, DATE_PICKER_FORMAT).toDate()
      )
      setValue(
        formSchema?.stopDateCounting.name,
        moment(rowData?.closeSystemStartDate, DATE_PICKER_FORMAT).toDate()
      )

      setNotiStartDate(
        rowData?.notificationStartDate &&
          moment(rowData?.notificationStartDate, DATE_PICKER_FORMAT).toDate()
      )
      setNotiStopDate(
        rowData?.notificationEndDate &&
          moment(rowData?.notificationEndDate, DATE_PICKER_FORMAT).toDate()
      )
      setStartDateCounting(
        rowData?.openSystemStartDate &&
          moment(rowData?.openSystemStartDate, DATE_PICKER_FORMAT).toDate()
      )
      setStopDateCounting(
        rowData?.closeSystemStartDate &&
          moment(rowData?.closeSystemStartDate, DATE_PICKER_FORMAT).toDate()
      )

      formSchema?.notiType && setValue(formSchema?.notiType?.name, rowData?.notiType)

      setNotiMessage(rowData.message)
      setCheckRadio(rowData.isActive)
      setUsersRole(rowData.usersRole)
      clearErrors()
    } else {
      setValue(formSchema.notificationMessage.name, '')
      setValue(formSchema.activeStatus.name, '')
      setValue(formSchema.usersRole.name, null)
      setValue(formSchema.notificationStartDate.name, '')
      setValue(formSchema.notificationStopDate.name, '')
      setValue(formSchema.startDateCounting.name, '')
      setValue(formSchema.stopDateCounting.name, '')
    }
  }, [rowData])

  const onEditorChange = (evt) => {
    const data = evt.editor.getData()
    const text = evt.editor.document.getBody().getText()
    if (data.length > 0) {
      setValue(formSchema.notificationMessage.name, data)
      clearErrors(formSchema.notificationMessage.name)
      setTextLength(text.length)
    } else {
      setValue(formSchema.notificationMessage.name)
      setTextLength(0)
    }
  }

  const removeTagsHtml = (str) => {
    if (str === null || str === '') return false
    else str = str.toString()

    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, '')
  }

  return (
    <>
      <Row style={{ marginTop: 5 }}>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(
              formSchema?.notificationMessage?.validators,
              formSchema?.notificationMessage?.label
            )}
          </ControlLabel>
        </Col>
        <Col lg={18} md={18} sm={24} xs={24}>
          <ErrorMessage error={errors[formSchema.notificationMessage.name]} />
          <Controller
            name={formSchema.notificationMessage.name}
            control={control}
            rules={isValidators(formSchema.notificationMessage.validators)}
            // defaultValue={formSchema?.notificationMessage}
            // name={formSchema.notificationMessage.name}
            // control={control}
            defaultValue={rowData?.message || null}
            // rules={isValidators(formSchema.notificationMessage.validators)}
            render={(props) => {
              return (
                <CKEditor
                  data={props.value}
                  style={{ marginTop: 10 }}
                  config={{
                    versionCheck: false,
                    toolbar: [['Bold', 'Italic', 'TextColor', 'BGColor']],
                    contentsCss: [
                      'https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;600&display=swap',
                      'body { font-size: "1rem"; font-family: "Sarabun", sans-serif; }',
                    ],
                    height: 250,
                    extraPlugins: 'colorbutton,colordialog',
                    // colorButton_colors: 'CF5D4E,454545,FFF,DDD,CCEAEE,66AB16',
                    colorButton_enableAutomatic: false,
                    // removeButtons: 'PasteFromWord',
                    colorButton_enableMore: true,
                  }}
                  onChange={onEditorChange}
                />
              )
            }}
          />
          <ShowLimitLength textLength={textLength} maxLength={maxLength} />
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(formSchema.activeStatus.validators, formSchema.activeStatus.label)}
          </ControlLabel>
        </Col>
        <Col lg={18} md={18} sm={24} xs={24}>
          <ErrorMessage error={errors[formSchema.activeStatus.name]} />
          <Controller
            name={formSchema.activeStatus.name}
            control={control}
            defaultValue={rowData?.activeStatus || '0'}
            rules={isValidators(formSchema.activeStatus.validators)}
            render={(props) => {
              return (
                <RadioGroup
                  inline
                  value={props.value}
                  onChange={(value) => {
                    props.onChange(value)
                    setCheckRadio(value)
                  }}
                >
                  {formSchema.activeStatus.options.map((item) => (
                    <Radio key={item.value} value={item.value}>
                      <p style={{ marginTop: -3 }}>{item.label}</p>
                    </Radio>
                  ))}
                </RadioGroup>
              )
            }}
          />
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(formSchema.usersRole.validators, formSchema.usersRole.label)}
          </ControlLabel>
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <ErrorMessage error={errors[formSchema.usersRole.name]} />
          <Controller
            name={formSchema.usersRole.name}
            control={control}
            defaultValue={formSchema.usersRole.value}
            rules={isValidators(formSchema.usersRole.validators)}
            render={(props) => {
              return (
                <CheckPicker
                  sticky
                  data={formSchema.usersRole.options}
                  defaultValue={formSchema.usersRole.defaultValue}
                  value={props.value}
                  block
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                    setUsersRole(value)
                    // console.log('value', value)
                    if (value.length == 0) {
                      setValue(formSchema.usersRole.name, null)
                    }
                  }}
                />
              )
            }}
          />
        </Col>
      </Row>

      {/* {useType != 1 && (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              
              <ControlLabel>
                {requiredFiled(formSchema?.notiType?.validators, formSchema?.notiType?.label)}
              </ControlLabel>
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema?.notiType?.name]} />
              <Controller
                name={formSchema?.notiType?.name}
                control={control}
                // defaultValue={costNameOption}
                rules={isValidators(formSchema?.notiType?.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={formSchema?.notiType?.options}
                      value={props.value}
                      style={{ marginTop: '3px', width: '100%' }}
                      searchable={false}
                      placeholder="เลือก"
                      onChange={(value) => {
                        // if (value === 'ค่าบริหารจัดการสำนักงาน') {
                        //   setSubCostNameShow(2)
                        // } else {
                        //   setSubCostNameShow(1)
                        // }
                        // console.log('value => ', value)
                        setUseTypeST(value)

                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
          </Row>
        </>
      )} */}

      {useType != 0 && (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(
                  formSchema?.startDateCounting?.validators,
                  formSchema?.startDateCounting?.label
                )}
              </ControlLabel>
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema?.startDateCounting?.name]} />
              <Controller
                key={formSchema?.startDateCounting?.name}
                name={formSchema?.startDateCounting?.name}
                control={control}
                defaultValue={
                  formSchema?.startDateCounting?.value
                    ? moment(formSchema?.startDateCounting?.value, DATE_PICKER_FORMAT).toDate()
                    : moment().startOf('day').toDate()
                }
                rules={isValidators(formSchema?.startDateCounting?.validators)}
                render={(props) => {
                  return (
                    <DatePickerCustom
                      {...props}
                      placement="auto"
                      value={
                        startDateCounting && moment(startDateCounting, DATE_PICKER_FORMAT).toDate()
                      }
                      disabledDate={(date) =>
                        stopDateCounting && moment(stopDateCounting).isBefore(date, new Date())
                      }
                      onChange={(value) => {
                        setStartDateCounting(value)
                        setValue(formSchema?.startDateCounting?.name, value)
                        if (value) {
                          clearErrors(formSchema?.startDateCounting.name)
                        }
                      }}
                    />
                  )
                }}
              />
            </Col>
          </Row>
        </>
      )}

      {useType != 0 && (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(
                  formSchema?.stopDateCounting?.validators,
                  formSchema?.stopDateCounting?.label
                )}
              </ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema?.stopDateCounting?.name]} />
              <Controller
                key={formSchema?.stopDateCounting?.name}
                name={formSchema?.stopDateCounting?.name}
                control={control}
                defaultValue={
                  formSchema?.stopDateCounting?.value
                    ? moment(formSchema?.stopDateCounting?.value, DATE_PICKER_FORMAT).toDate()
                    : moment().startOf('day').toDate()
                }
                rules={isValidators(formSchema?.stopDateCounting?.validators)}
                render={(props) => {
                  return (
                    <DatePickerCustom
                      {...props}
                      placement="auto"
                      value={
                        stopDateCounting && moment(stopDateCounting, DATE_PICKER_FORMAT).toDate()
                      }
                      disabledDate={(date) =>
                        startDateCounting && moment(startDateCounting).isAfter(date, new Date())
                      }
                      onChange={(value) => {
                        setStopDateCounting(value)
                        setValue(formSchema?.stopDateCounting?.name, value)
                        if (value) {
                          clearErrors(formSchema?.stopDateCounting.name)
                        }
                      }}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>
        </>
      )}

      <Row style={{ marginTop: 10 }}>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(
              formSchema?.notificationStartDate?.validators,
              formSchema?.notificationStartDate?.label
            )}
          </ControlLabel>
        </Col>

        <Col lg={8} md={8} sm={24} xs={24}>
          <ErrorMessage error={errors[formSchema?.notificationStartDate?.name]} />
          <Controller
            key={formSchema?.notificationStartDate?.name}
            name={formSchema?.notificationStartDate?.name}
            control={control}
            defaultValue={
              formSchema?.notificationStartDate?.value
                ? moment(formSchema?.notificationStartDate?.value, DATE_PICKER_FORMAT).toDate()
                : moment().startOf('day').toDate()
            }
            rules={isValidators(formSchema?.notificationStartDate?.validators)}
            render={(props) => {
              return (
                <DatePickerCustom
                  {...props}
                  placement="auto"
                  value={notiStartDate && moment(notiStartDate, DATE_PICKER_FORMAT).toDate()}
                  disabledDate={(date) =>
                    notiStopDate && moment(notiStopDate).isBefore(date, new Date())
                  }
                  onChange={(value) => {
                    setNotiStartDate(value)
                    setValue(formSchema?.notificationStartDate?.name, value)
                    if (value) {
                      clearErrors(formSchema?.notificationStartDate.name)
                    }
                  }}
                />
              )
            }}
          />
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <ControlLabel>
            {requiredFiled(
              formSchema?.notificationStopDate?.validators,
              formSchema?.notificationStopDate?.label
            )}
          </ControlLabel>
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          <ErrorMessage error={errors[formSchema?.notificationStopDate?.name]} />
          <Controller
            key={formSchema?.notificationStopDate?.name}
            name={formSchema?.notificationStopDate?.name}
            control={control}
            defaultValue={
              formSchema?.notificationStopDate?.value
                ? moment(formSchema?.notificationStopDate?.value, DATE_PICKER_FORMAT).toDate()
                : moment().startOf('day').toDate()
            }
            rules={isValidators(formSchema?.notificationStopDate?.validators)}
            render={(props) => {
              return (
                <DatePickerCustom
                  {...props}
                  placement="auto"
                  value={notiStopDate && moment(notiStopDate, DATE_PICKER_FORMAT).toDate()}
                  disabledDate={(date) =>
                    notiStartDate && moment(notiStartDate).isAfter(date, new Date())
                  }
                  onChange={(value) => {
                    setNotiStopDate(value)
                    setValue(formSchema?.notificationStopDate?.name, value)
                    if (value) {
                      clearErrors(formSchema?.notificationStopDate.name)
                    }
                  }}
                />
              )
            }}
          />
        </Col>
      </Row>
    </>
  )
}
